import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { NBookings } from '../interfaces/services/bookings.interfaces'

export const getBookingsPerFacility = (
  id: string,
  fromDate?: Date,
  toDate?: Date
): Promise<AxiosResponse<NBookings.NGetPerFacility.IResponse>> => {
  return axiosAuth.get<NBookings.NGetPerFacility.IResponse>(
    createUrl(`/bookings/get-per-facility/${id}`, {
      ...(fromDate && { fromDate: fromDate.getTime() }),
      ...(toDate && { toDate: toDate.getTime() }),
    })
  )
}

export const getBookingsPerUnit = (
  unitId: string,
  fromDate?: Date
): Promise<AxiosResponse<NBookings.NGetPerUnit.IResponse>> => {
  return axiosAuth.get<NBookings.NGetPerUnit.IResponse>(
    createUrl(`/bookings/get-per-unit/${unitId}`, {
      ...(fromDate && { fromDate: fromDate.getTime() }),
    })
  )
}

export const createBooking = (
  body: NBookings.NCreate.IRequestBody
): Promise<AxiosResponse<NBookings.NCreate.IResponse>> => {
  return axiosAuth.post<NBookings.NCreate.IResponse>(
    createUrl(`/bookings/booking`),
    body
  )
}

export const deleteBooking = (
  id: string
): Promise<AxiosResponse<NBookings.NDel.IResponse>> => {
  return axiosAuth.delete<NBookings.NDel.IResponse>(
    createUrl(`/bookings/booking/${id}`)
  )
}

export const bookingQueries = {
  scope: { scope: 'facility' },
  getBookingsPerFacility: (
    facilityId?: string,
    fromDate?: Date,
    toDate?: Date
  ) =>
    queryOptions({
      queryKey: [
        { scope: 'facility', entity: 'facility', facilityId, fromDate, toDate },
      ],
      enabled: !!facilityId,
      queryFn: async ({ queryKey }) => {
        return (
          await getBookingsPerFacility(
            queryKey[0].facilityId!,
            fromDate,
            toDate
          )
        ).data.data
      },
    }),
  getBookingsPerUnit: (unitId?: string, fromDate?: Date) =>
    queryOptions({
      queryKey: [{ scope: 'facility', entity: 'unit', unitId, fromDate }],
      enabled: !!unitId,
      queryFn: async ({ queryKey }) => {
        return (await getBookingsPerUnit(queryKey[0].unitId!, fromDate)).data
          .data
      },
    }),
}
